import { Inject, Injectable } from '@angular/core';
import { Headers, Http, Request, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import { LoopBackConfig } from "./../../../shared/sdk/lb.config"; // Need Dependency - PageBuilder
import { LoopBackAuth } from './../../../shared/sdk/services/core/auth.service'; // Need Dependency - PageBuilder
import CryptoJS from 'crypto-js';
import { RecruitmentAuth } from '../../../shared/recruitment/recruitment-auth';
import { Sha1Service } from '../../../providers/secrypt';
import { sortObject } from '../../../helpers/root-page.helper';

@Injectable()
export class ApiServiceProvider {

  public SFGoAuth: any;
  public SFGoStorage: any;

  public path: any;
  public oldPATHUrl: any;
  public newPATH: boolean = false;
  public newPATHUrl: any;

  public pageBuilderObservable: any;

  public pathPB: any;

  // Extension Comment Turbo Console Log
  // Ctrl + Alt + L for display comment
  // Shift + Alt + C for show comment - FOR PRODUCTION
  // Shift + Alt + D for delete
  // Shift + Alt + U for uncomment - FOR DEVELOP

  constructor(
    private _http: Http,
    private _storage: Storage,
    private recruitmentAuth: RecruitmentAuth,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private sha1: Sha1Service) {
    this.getStorage();

  }

   async sfEncrypt(data: string) {
    const thesalt: string = '5unfi5h60l8pb4ck';
    try {
      return new Promise<string>(async (resolve) => {
        const encryptedBody = CryptoJS.AES.encrypt(data, thesalt).toString();
        resolve(encryptedBody)
      });
    } catch (e) {
      throw e;
    }
  }

  async getStorage() {
    return new Promise(async (resolve) => {
      await this.getStorageSfGoAuth();
      await this.getStorageSfGoStorage();
      resolve(true);
    });
  }

  async getStorageSfGoStorage(): Promise<any> {
    // console.log("TCL: Get Storage");

    const pathDev = 'https://api.greatdayhr.com/pagebuilder/dev';
    const pathProd = 'https://api.greatdayhr.com/pagebuilder';
    this.pathPB = pathProd;

    return new Promise((resolve) => {
      this._storage.ready().then(() => {
        this._storage.get('SFGoStorage').then(async (hasil) => {
          if (hasil != null && hasil != undefined) {
            this.SFGoStorage = JSON.parse(hasil);
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin) {
              this.oldPATHUrl = this.SFGoStorage.storedPrelogin.GOPATH;
            } else {
              this.oldPATHUrl = this.path;
            }
            let path;
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin &&
              this.SFGoStorage.storedPrelogin.hasOwnProperty('GOPATHNEW') && this.SFGoStorage.storedPrelogin.GOPATHNEW) {
              // console.log("TCL: New Path Found");
              this.newPATH = true;
              path = this.SFGoStorage.storedPrelogin.GOPATHNEW;
              this.newPATHUrl = path;
            } else {
              // console.log("TCL: New Path Not Found");
              this.newPATH = false;
            }

            try {
                let appMode = await this._storage.get('pageBuilderAppMode');
                let env = 'prod';

                let _pageBuilderEnv = {
                    'path': pathProd,
                    'pathDev': pathDev,
                    'pathProd': pathProd,
                    'isProd': true
                };

                if (appMode === null || appMode === undefined) {
                  // await this.getAppMode();
                  // appMode = await this._storage.get('pageBuilderAppMode');
                }

                if (!appMode) {
                    const path: string = this.recruitmentAuth.getPath();
                    let findStaging = path.indexOf(path);

                    if (findStaging !== -1) {
                      env = 'dev';
                      _pageBuilderEnv.isProd = false;
                      _pageBuilderEnv.path = pathDev;
                      this.pathPB = pathDev;
                    }
                }

                if (appMode === 'development') {
                    env = 'dev';
                    _pageBuilderEnv.isProd = false;
                    _pageBuilderEnv.path = pathDev;
                    this.pathPB = pathDev;
                }

                console.log('appMode', appMode);
                console.log(env);
                console.log('_pageBuilderEnv', _pageBuilderEnv);

                this._storage.set('pageBuilderEnv', JSON.stringify(_pageBuilderEnv));
            } catch(error) {}

            // this.newPATHUrl = 'http://localhost:30000' // local nestjs;
            // this.newPATHUrl = 'http://localhost:5000' // local loopback;
            resolve(true);
          }
        });
      });
    });
  }

  getStorageSfGoAuth(): Promise<any> {
    return new Promise(async (resolve) => {
      this.path = LoopBackConfig.getPath();
      // console.log('TCL: ', this.path);
      this._storage.ready().then(() => {
        this._storage.get('SFGoAuth').then(hasil => {
          if (hasil != null && hasil != undefined) {
            this.SFGoAuth = JSON.parse(hasil);
            resolve(true);
          }
        });
      });
    })
  }

  public authenticate(headers: Headers): void {
    if (this.auth.getAccessTokenId()) {
      headers.append(
        'Authorization',
        LoopBackConfig.getAuthPrefix() + this.auth.getAccessTokenId()
      );
    }
  }

  changeURL(newPATH): boolean {
    if (newPATH && this.newPATH) {
      return true;
    } else {
      return false;
    }
  }

  async getAppMode() {
    console.log('get APP MODE');
    console.log(await this._storage.get('pageBuilderAppMode'));
    try {
      if (this.auth.getAccessTokenId()) {
          this.api('GET NO BODY', null, null, '/appmode', '/appmode').then((result) => {
            this._storage.set('pageBuilderAppMode', result._body);
            console.log('APP MODE', result);
            return result._body;
          }, error => {
            console.log('ERROR', error);
            return error;
          });
      }
    } catch(error) {
      return 'production';
    }
  }

  async api(method, params?, body?, loopbackApi?, nestApi?, newPATH = null, sendPATH = false, cfc = false, cfcRoute?, unsubscribe?, unsubcribeKey?, externalUrl?, externalUrlLink?): Promise<any> {
    return new Promise(async (resolve, reject) => {
      await this.getStorage();
      console.log(unsubcribeKey);

      let pageBuilderObservable;

      if (!this.pageBuilderObservable) {
        this.pageBuilderObservable = [];
      }
      console.log(this.pageBuilderObservable, unsubscribe);

      if (unsubscribe && unsubcribeKey) {
        if (this.pageBuilderObservable && this.pageBuilderObservable.length > 0) {
          let findObservable = this.pageBuilderObservable.filter(item => item.key === unsubcribeKey);
          console.log(findObservable);

          if (findObservable) {
            findObservable.forEach(itemObservable => {
              console.log(itemObservable);
              itemObservable.observable.unsubscribe();
            })
          }
        }
        this.pageBuilderObservable = [];
      }

      if (!nestApi) nestApi = loopbackApi;

      console.log('this.oldPATHUrl', this.oldPATHUrl);
      console.log('this.newPATHUrl', this.newPATHUrl);

      let path;
      if (newPATH !== null) {
        path = this.oldPATHUrl + loopbackApi;
        if (this.changeURL(newPATH)) path = this.newPATHUrl + nestApi;
      } else {
        path = this.oldPATHUrl + loopbackApi;
        if (this.newPATHUrl) path = this.newPATHUrl + nestApi;
      }

      if (params) {
        if (params.charAt(0) === '&') {
          params = params.substr(1, 100000000);
            console.log('slice', params);
            const paramsFinal = '?' + params;
            params = paramsFinal;
            console.log('paramsFinal', params);
        }
      }

      if (this.newPATHUrl) {
        if (params && sendPATH) params = params + '&goPath=' + encodeURIComponent(this.oldPATHUrl) + '&goPathNew=' + encodeURIComponent(this.newPATHUrl);
      } else {
        if (params && sendPATH) params = params + '&goPath=' + encodeURIComponent(this.oldPATHUrl);
      }

      if (params) {
        path = path + params;
      }


      let headers: Headers = new Headers();
      headers.append('Content-Type', 'application/json');
      if (cfc) {
        headers.append('route', cfcRoute);
      }
      if (externalUrl) {
        headers.append('external-url', externalUrlLink);
      }
      this.authenticate(headers);

      let result = await this.callAPI(method, headers, path, body, pageBuilderObservable, unsubcribeKey);
      resolve(result);
    });
  }

  async apiPB(method, params?, body?, nestApi?, unsubscribe?, unsubcribeKey?, encryptedBody?): Promise<any> {
    return new Promise(async (resolve, reject) => {
      await this.getStorage();
      console.log(unsubcribeKey);

      let pageBuilderObservable;

      if (!this.pageBuilderObservable) {
        this.pageBuilderObservable = [];
      }
      console.log(this.pageBuilderObservable, unsubscribe);

      if (unsubscribe && unsubcribeKey) {
        if (this.pageBuilderObservable && this.pageBuilderObservable.length > 0) {
          let findObservable = this.pageBuilderObservable.filter(item => item.key === unsubcribeKey);
          console.log(findObservable);

          if (findObservable) {
            findObservable.forEach(itemObservable => {
              console.log(itemObservable);
              itemObservable.observable.unsubscribe();
            })
          }
        }
        this.pageBuilderObservable = [];
      }


      let path = this.pathPB + nestApi;

      if (params) {
        if (params.charAt(0) === '&') {
          params = params.substr(1, 100000000);
            console.log('slice', params);
            const paramsFinal = '?' + params;
            params = paramsFinal;
            console.log('paramsFinal', params);
        }
      }

      if (params) {
        path = path + params;
      }

      let headers: Headers = new Headers();
      if (this.newPATHUrl) {
        headers.append('API-Host', this.newPATHUrl);
      } else {
        headers.append('API-Host', this.oldPATHUrl);
      }
      headers.append('Content-Type', 'application/json');
      if (encryptedBody) {
        headers.append('urlBody', `${encryptedBody}`);
      }
      this.authenticate(headers);

      let result = await this.callAPI(method, headers, path, body, pageBuilderObservable, unsubcribeKey);
      resolve(result);
    });
  }

  callAPI(method, headers, path, body, pageBuilderObservable, unsubcribeKey) {
    return new Promise(async (resolve, reject) => {
      console.log('masuk page builder');
      if (method == 'GET' || method == 'DELETE') {
        const hash = await this.getXGDParams(body);
        console.log('masuk page builder 1',  hash);
        if (hash !== '' && hash !== null && hash !== undefined) {
          headers.append('X-GD-Params', `${hash}`);
        }
        headers.append('cache', 'force-cache');
        let request: Request = new Request(
          new RequestOptions({
            headers: headers,
            method: method,
            url: path,
            body: body ? JSON.stringify(body) : undefined
          })
        );
        // pageBuilderObservable = from(fetch(path, {
        //   cache: 'force-cache',
        //   method: method,
        //   body: body ? JSON.stringify(body) : undefined,
        //   headers: headers
        // })).map(data => data.json())
        //   .subscribe((result: any) => {
        //     resolve(result);
        //   }, error => {
        //     const errorResult = error.json();
        //     errorResult.isError = true;
        //     resolve(errorResult);
        //   });

        pageBuilderObservable = this._http.request(request)
          .map(data => data.json())
          .subscribe((result: any) => {
            resolve(result);
          }, error => {
            const errorResult = error.json();
            errorResult.isError = true;
            resolve(errorResult);
          });
        let observableItem = {
          key: unsubcribeKey? unsubcribeKey: new Date().getTime(),
          observable: pageBuilderObservable
        }
        console.log(observableItem);
        this.pageBuilderObservable.push(observableItem);
      } else if (method == 'POST' || method == 'PUT') {
        const hash = await this.getXGDParams(body);
        console.log('masuk page builder 2',  hash);
        if (hash !== '' && hash !== null && hash !== undefined) {
          headers.append('X-GD-Params', `${hash}`);
        }
        headers.append('cache', 'force-cache');
        let request: Request = new Request(
          new RequestOptions({
            headers: headers,
            method: method,
            url: path,
            body: body ? JSON.stringify(body) : undefined
          })
        );
        // pageBuilderObservable = from(fetch(path, {
        //   cache: 'force-cache',
        //   method: method,
        //   body: body ? JSON.stringify(body) : undefined,
        //   headers: headers
        // })).map(data => data.json())
        //   .subscribe((result: any) => {
        //     resolve(result);
        //   }, error => {
        //     const errorResult = error.json();
        //     errorResult.isError = true;
        //     resolve(errorResult);
        //   });
        pageBuilderObservable = this._http.request(request)
          .map(data => data.json())
          .subscribe((result: any) => {
            // console.log('respond APi', result)
            resolve(result);
          }, error => {
            const errorResult = error.json();
            errorResult.isError = true;
            resolve(errorResult);
          })

        let observableItem = {
          key: unsubcribeKey? unsubcribeKey: new Date().getTime(),
          observable: pageBuilderObservable
        }
        console.log(observableItem);
        this.pageBuilderObservable.push(observableItem);
      } else if (method == 'GET NO BODY') {
        const hash = await this.getXGDParams(body);
        console.log('masuk page builder 3',  hash);
        if (hash !== '' && hash !== null && hash !== undefined) {
          headers.append('X-GD-Params', `${hash}`);
        }
        let request: Request = new Request(
          new RequestOptions({
            headers: headers,
            method: 'GET',
            url: path,
            body: body ? JSON.stringify(body) : undefined
          })
        );
        pageBuilderObservable = this._http.request(request)
          .subscribe((result: any) => {
            resolve(result);
          }, error => {
            const errorResult = error.json();
            errorResult.isError = true;
            resolve(errorResult);
          });
          let observableItem = {
            key: unsubcribeKey? unsubcribeKey: new Date().getTime(),
            observable: pageBuilderObservable
          }
          console.log(observableItem);
          this.pageBuilderObservable.push(observableItem);
      }
    });
  }

  async getXGDParams(params: any) {
    try {
      if (params) {
        let data = params;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) { }
        } else {
          const jsonString = JSON.stringify(data);
          try {
            data = JSON.parse(jsonString);
          } catch (e) { }
        }
        const salt = `5unf15hD4740N`; //(localStorage.getItem('$username')) ? `5unf15h${localStorage.getItem('$username')}D4740N` : `5unf15hD4740N`;
        return this.sha1.getHash(JSON.stringify(sortObject(data)).trim(), salt, 7).toUpperCase();
      }
      return '';
    } catch (error) {
      console.log(error);
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/api/api-service.ts